import React, { Fragment, useEffect, useState } from "react"
import { useFormik } from "formik"
import PropTypes from "prop-types"
import _find from "lodash/find"
import _map from "lodash/map"
import { connect } from "react-redux"

import CardFixedVoice from "../../components/Inputs/CardFixedVoice"
import InputField from "../../components/Inputs/InputField"
import BreadcrumbRouter from "../../components/Breadcrumb"
import TextArea from "../../components/Inputs/TextArea"
import ButtonFixedVoice from "../../components/ButtonFixedVoice"
import CardInfo from "../../components/Inputs/CardInfo"
import DropFile from "../../components/Inputs/DropFile"
import SelectBoxLabel from "../../components/Inputs/SelectBoxLabel"
import InputPhone from "../../components/Inputs/InputPhone"
import SpinnerLoad from "../../components/SpinnerLoad"
import Typograph from "../../../../components/Typograph"
import { showToast } from "../../../../components/Toast"

import styles from "./styles.css"

import { removeMaskCPFCNPJ } from "services/utils/mask"
import { sendGtmEventFormSubmit } from "services/utils/sendGtm"
import {
  CATEGORIES,
  DEFAULT_MESSAGE,
  INITIAL_VALUES_ANALYST,
  NEW_NUMBER,
  OPTIONS_ATTENDANCE,
  validate
} from "./constants"
import {
  newSpecialistAnalysis,
  partnerLocality,
  partnerLocalityAreaLocals,
  partnerLocalityUfs
} from "services/state/fixedVoice/action"

const ExpertAnalysis = ({
  history,
  loading,
  loadingOrder,
  localitiesList,
  localityCnl,
  newSpecialistAnalysis,
  partnerLocalityUfs,
  partnerLocality,
  partnerLocalityAreaLocals,
  documentPartner,
  documentsSubsidiary,
  namePartner
}) => {
  const [ufCurrent, setUfCurrent] = useState("")

  const { ufs, areaLocals, localitiesName } = localitiesList
  const subsidiary = _map(documentsSubsidiary, "cnpj")
  const documentOptions = [...subsidiary, documentPartner]
  const ufsSorted = ufs && ufs.sort()
  const areasSorted = areaLocals && areaLocals.sort()
  const localities = localitiesName && localitiesName.sort()

  const formikAnalyst = useFormik({
    initialValues: { ...INITIAL_VALUES_ANALYST, customerFullName: namePartner },
    validate,
    onSubmit: async (valuesForm) => {
      try {
        const codeLocality = _find(localityCnl, [
          "locality",
          valuesForm.locality
        ])
        const category = _find(CATEGORIES, [
          "desc",
          valuesForm.typeOfAttendance
        ])

        const order = {
          category: category.desc,
          typeOfResponse: "SPECIALIST"
        }

        const toBase64 = (file) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = () => resolve(reader.result)
            reader.onerror = reject
            reader.readAsDataURL(file)
          })

        const contentBase64 = await toBase64(valuesForm.file)

        const payload = {
          category: category.name,
          localityCode: codeLocality.cnl,
          localityLocalArea: valuesForm.city,
          localityName: valuesForm.locality,
          localityUf: valuesForm.state,
          note: valuesForm.reason,
          requestUserDocument: removeMaskCPFCNPJ(valuesForm.customerDocument),
          requestUserEmail: valuesForm.customerEmail,
          requestUserName: valuesForm.customerFullName,
          requestUserPhone: valuesForm.customerPhone,
          responsibleUserName: "Portal de Clientes",
          file: {
            name: valuesForm.file.name,
            type: "xlsx",
            content: contentBase64.split(",")[1],
            createdBy: "Portal de Clientes",
            UpdateBy: "Portal de Clientes",
            length: valuesForm.file.size
          }
        }

        sendGtmEventFormSubmit(
          "Voz Fixa - Solicitar análise de especialista Algar"
        )

        newSpecialistAnalysis(order, payload, (resp) => {
          if (resp.code === 200 || resp.code === 201) {
            history.push({
              pathname: "/fixed-voice/confirm-screen"
            })
          } else {
            showToast({
              type: "error",
              message:
                resp.message ||
                "Ocorreu um erro na solicitação. Por favor, tente novamente mais tarde."
            })
          }
        })
      } catch (e) {
        showToast({
          type: "error",
          message:
            e.getErrorMessage ||
            "Ocorreu um erro na solicitação. Por favor, tente novamente mais tarde."
        })
      }
    }
  })

  const isDisabledArea = !formikAnalyst.values.state
  const isDisabledLocalities = isDisabledArea || !formikAnalyst.values.city
  const isDisabledSubmit = formikAnalyst.isValid && formikAnalyst.dirty
  const category = _find(CATEGORIES, [
    "desc",
    formikAnalyst.values.typeOfAttendance
  ])

  const onSubmitAnalyze = () => {
    formikAnalyst.handleSubmit()
  }

  const getAreaLocals = () => {
    partnerLocalityAreaLocals(formikAnalyst.values.state)
  }

  const getAreaLocalities = () => {
    partnerLocality(formikAnalyst.values.state, formikAnalyst.values.city)
  }

  useEffect(() => {
    const { setFieldValue, setFieldTouched } = formikAnalyst

    if (!ufs) {
      partnerLocalityUfs()
      setFieldValue("areaLocal", "")
      setFieldValue("locality", "")
      setFieldTouched("locality", false)
    }
  }, [ufs])

  useEffect(() => {
    if (
      formikAnalyst.values.state &&
      formikAnalyst.values.state !== ufCurrent
    ) {
      setUfCurrent(formikAnalyst.values.state)
      getAreaLocals()
    }
  }, [formikAnalyst.values.state])

  useEffect(() => {
    const { setFieldValue, setFieldTouched } = formikAnalyst

    if (formikAnalyst.values.city) {
      setFieldValue("locality", "")
      setFieldTouched("locality", false)
      getAreaLocalities()
    }
  }, [formikAnalyst.values.city])

  return (
    <Fragment>
      <BreadcrumbRouter />

      <div>
        <Typograph
          htmlTag="h1"
          size="x_large"
          color="outer_space"
          weight="bold"
        >
          Solicitar análise de especialista Algar
        </Typograph>

        <CardFixedVoice>
          <Typograph
            htmlTag="h2"
            size="medium"
            color="outer_space"
            weight="semi_bold"
            classNames={styles.titleCard}
          >
            Selecione o tipo de atendimento que precisa
          </Typograph>

          <SelectBoxLabel
            options={OPTIONS_ATTENDANCE}
            values={NEW_NUMBER.typeOfAttendance}
            formik={formikAnalyst}
          />
          <CardInfo hasClose={true}>
            <Typograph
              htmlTag="span"
              size="extra_small"
              color="true_blue"
              weight="semi_bold"
            >
              {DEFAULT_MESSAGE.SPECIALIST_INFO}
            </Typograph>
          </CardInfo>
        </CardFixedVoice>

        {formikAnalyst.values.typeOfAttendance !== "" && (
          <div>
            <CardFixedVoice>
              <Typograph
                htmlTag="h2"
                size="medium"
                color="outer_space"
                weight="semi_bold"
                classNames={styles.titleCard}
              >
                Dados do cliente parceiro
              </Typograph>
              <InputField
                formValues={{
                  ...NEW_NUMBER.customerFullName,
                  isDisabled: true
                }}
                formik={formikAnalyst}
              />
              <SelectBoxLabel
                options={documentOptions}
                values={NEW_NUMBER.customerDocument}
                formik={formikAnalyst}
              />

              <div className={styles.infoContact}>
                <InputField
                  formValues={NEW_NUMBER.customerEmail}
                  formik={formikAnalyst}
                />
                <InputPhone
                  formValues={NEW_NUMBER.customerPhone}
                  formik={formikAnalyst}
                />
              </div>

              {loading ? (
                <div className={styles.load_container}>
                  <SpinnerLoad />
                </div>
              ) : (
                <div>
                  <div className={styles.infoContact}>
                    <SelectBoxLabel
                      options={ufsSorted}
                      values={NEW_NUMBER.state}
                      formik={formikAnalyst}
                    />
                    <SelectBoxLabel
                      options={areasSorted}
                      values={{
                        ...NEW_NUMBER.city,
                        isDisabled: isDisabledArea
                      }}
                      formik={formikAnalyst}
                    />
                  </div>
                  <SelectBoxLabel
                    options={localities}
                    values={{
                      ...NEW_NUMBER.locality,
                      isDisabled: isDisabledLocalities
                    }}
                    formik={formikAnalyst}
                  />
                </div>
              )}
            </CardFixedVoice>

            <CardFixedVoice>
              <Typograph
                htmlTag="h2"
                size="medium"
                color="outer_space"
                weight="semi_bold"
                classNames={styles.titleCard}
              >
                Insira a quantidade de números para o atendimento
              </Typograph>

              <CardInfo>
                <span className={styles.fileInfo}>
                  Para continuar, faça o download do modelo de planilha
                  <a download href={category.file}>
                    {" "}
                    clicando aqui
                  </a>
                  , preencha os dados e faça o anexo. Tamanho máximo 200 kB.
                </span>
              </CardInfo>
              <DropFile formik={formikAnalyst} />
            </CardFixedVoice>

            <CardFixedVoice>
              <Typograph
                htmlTag="h2"
                size="medium"
                color="outer_space"
                weight="semi_bold"
                classNames={styles.titleCard}
              >
                Descreva o motivo da sua solicitação
              </Typograph>

              <TextArea formValues={NEW_NUMBER.reason} formik={formikAnalyst} />
            </CardFixedVoice>

            <div className={styles.container_buttons}>
              <ButtonFixedVoice
                isOutline
                name="Cancelar"
                linkName="/fixed-voice/specialist-requests"
                className={styles.cancelButton}
              />

              <ButtonFixedVoice
                onAction={onSubmitAnalyze}
                name={"Enviar solicitação"}
                isDisabled={!isDisabledSubmit}
                isLoading={loadingOrder}
                className={styles.sendButton}
              />
            </div>
          </div>
        )}
      </div>
    </Fragment>
  )
}

ExpertAnalysis.propTypes = {
  history: PropTypes.object,
  localitiesList: PropTypes.object,
  localityCnl: PropTypes.array,
  loadingOrder: PropTypes.bool,
  loading: PropTypes.bool,
  documentPartner: PropTypes.string,
  documentsSubsidiary: PropTypes.array,
  namePartner: PropTypes.string,
  newSpecialistAnalysis: PropTypes.func,
  partnerLocalityUfs: PropTypes.func,
  partnerLocality: PropTypes.func,
  partnerLocalityAreaLocals: PropTypes.func,
  error: PropTypes.bool
}

const mapStateToProps = ({ newOrder, customer }) => ({
  localitiesList: newOrder.localityResponse,
  localityCnl: newOrder.localities,
  loadingOrder: newOrder.loadingRequest,
  loading: newOrder.loading,
  documentPartner: customer.data.documentNumber,
  documentsSubsidiary: customer.data.subsidiaryList,
  namePartner: customer.data.name
})

export default connect(mapStateToProps, {
  newSpecialistAnalysis,
  partnerLocalityUfs,
  partnerLocality,
  partnerLocalityAreaLocals
})(ExpertAnalysis)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/ExpertAnalysis/index.js